import { T, H } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'

import Persistance from "../Persistence";

export interface Props {
    children?: React.ReactNode
    student: T.StudentDash
}
  
export interface State {
}

Persistance.setValues()

export class StudentDash extends React.Component<Props, any> {

  public makeNextEvent = (student: T.StudentDash) => {
    let events = student.upcomingSchedule
    let event = this.getNextEvent(events)

    if(event){
        return (
            <div className="w-full min-h-16 pb-4 my-1 border-b-2">
            <div className='w-full text-xs text-ellipsis overflow-hidden'>
                {event.description}
            </div>
            <div className='w-full text-xs text-left1'>
                {event.location}
            </div>
            <div className='w-full text-xs text-right'>
                {event.start_date}
            </div>
            <div className='w-full text-xs text-right'>
                {event.starts_at}-{event.ends_at}
            </div>
        </div>
        )
    }
    

    return (<div className='w-full min-h-16 p-1 my-1 pb-4 text-center leading-16 border-b-2 capitalize'>
        No Upcoming Scheduled Events
       </div>)

  }  

  public getNextEvent(events: T.Schedule[]): T.Schedule | false {

    events = events.flat()

    for (let e of events) {

        if(e.all_day){
            return e
        }

        let startTime = m(e.start_date + e.starts_at)
        let endtime = m(e.end_date + e.ends_at)
        
        if(m().isBefore(startTime) && m().isBefore(endtime) ){
            return e
        }
    }

    return false
  }

  public makeRecentExpenses = (student: T.StudentDash) => {
    let expenses = student.recentExpenses
    let expense = expenses[0]

   if(expense){
    return (
        <div className="w-full min-h-16 p-1 my-1 pb-4 border-b-2">
        <div className='w-full flex text-xs justify-between'>
            <div className='w-1/3 flex-none text-xs leading-loose'>
            ${expense.price} 
            </div>
            <div className='w-2/3 flex-auto text-right leading-loose text-xs text-ellipsis overflow-hidden'>
            {expense.description}    
            </div>
        </div>
        <div className='w-full flex text-xs justify-between'>
        <div className='w-1/2 flex-none leading-loose text-left text-xs'>
            {expense.category}
            </div>
            <div className='w-1/2 flex-auto leading-loose text-right text-xs'>
            {expense.date}   
            </div>
        </div>
    </div>
    )
   }
    
   return (<div className='w-full min-h-16 p-1 my-1 pb-4 text-center leading-16 border-b-2 capitalize'>
    No recent expenses
   </div>)

  }  

  public makeRecentNotes = (student: T.StudentDash) => {
    let notes = student.recentNotes
    
    let note = notes[0]
   
   if(note){
    return (
        <div className="w-full min-h-16 p-1 my-1">
        <div className='w-full text-xs text-elipsis'>
            {note.description}
        </div>
        <div className='w-full flex jusity-between text-xs  leading-1'>
            <div className='flex-auto text-left text-xs'>
                {note.course} 
            </div>
        </div>
        <div className='w-full flex text-xs justify-between'>
            <div className='flex-none text-left text-xs'>
                {H.turnMinutesToHours(Number(note.time_spent))}
            </div>
            <div className='flex-auto text-right text-xs'>
                {note.date}
            </div>
        </div>
    </div>
    )
   }
    
   return (<div className='flex w-full h-16 p-1 my-1'>
    <div className='w-full align-middle text-center leading-16 capitalize'>
       No recent notes 
    </div>
   </div>)

  }  

  public render(): React.ReactNode {
    const student: T.StudentDash = this.props.student
    return (
        <div id={`student-dash_${student.id}`} className="p-5 w-72">
        <div className="bg-white shadow-xl rounded-lg py-3">
            <div className="photo-wrapper p-2">
                <img className="w-32 h-32 rounded-full mx-auto" src="https://www.gravatar.com/avatar/2acfb745ecf9d4dccb3364752d17f65f?s=260&d=mp" alt="Student Name" />
            </div>
            <div className="p-2">
                <h3 className="text-center text-xl text-gray-900 font-medium leading-8">{student.name}</h3>
                <div className="text-center text-gray-400 text-s font-semibold">
                    <p>{`class of ${student.class}`}</p>
                </div>
                <div className='pt-2'>
                    <div className="text-right text-gray-600 text-xs">
                        Next Scheduled Event
                    </div>
                    {this.makeNextEvent(student)}
                </div>
               
                <div className='pt-2'>
                    <div className="text-right text-gray-600 text-xs">
                        Recent Expenses
                    </div>
                    {this.makeRecentExpenses(student)}
                </div>
               
                <div className='pt-2'>
                    <div className="text-right text-gray-600 text-xs">
                        Recent Notes
                    </div>
                    {this.makeRecentNotes(student)}
                </div>
            </div>
        </div>
    </div>
    )
  }  
  
}

export default  StudentDash